export class AdminApiError extends Error {
  constructor(
    public status: number,
    public path: string,
    public detail: string,
    public errorCode?: string,
    public retryAfter?: number,
  ) {
    let msg = detail;
    if (status === 402 || errorCode === 'eval_pool_exhausted' || errorCode === 'guest_ip_eval_exhausted' || errorCode === 'room_limit' || detail === 'eval_pool_exhausted' || detail === 'guest_ip_eval_exhausted' || detail === 'room_limit') {
      msg = 'Simulation limit reached. Upgrade to Pro to create more rooms. You can continue using the room editing and design for free.';
    } else if (!msg) {
      msg = status === 429
        ? 'You have several solves in progress already — wait for one to finish before starting another.'
        : 'An error occurred. Please try again.';
    } else if (msg.includes('→')) {
      msg = msg.split('→').pop()?.trim() ?? msg;
      msg = msg.replace(/^\d+:\s*/, '');
    }
    super(msg);
    this.name = 'AdminApiError';
  }
}

/** Parse FastAPI/BFF error body + closed headers into AdminApiError. */
export async function adminErrorFromResponse(
  res: Response,
  path: string,
): Promise<AdminApiError> {
  const headerCode = res.headers.get('x-error-code') ?? undefined;
  const retryRaw = res.headers.get('retry-after');
  const parsedRetry = retryRaw ? Number.parseInt(retryRaw, 10) : NaN;
  const retryAfter = Number.isFinite(parsedRetry) ? parsedRetry : undefined;
  const raw = await res.text().catch(() => '');
  try {
    const parsed = JSON.parse(raw) as {
      detail?: unknown;
      error?: unknown;
      error_code?: unknown;
      code?: unknown;
    };
    let detail = raw;
    if (typeof parsed.detail === 'string') detail = parsed.detail;
    else if (typeof parsed.error === 'string') detail = parsed.error;
    const bodyCode =
      (typeof parsed.error_code === 'string' && parsed.error_code)
      || (typeof parsed.code === 'string' && parsed.code)
      || undefined;
    return new AdminApiError(
      res.status,
      path,
      detail,
      headerCode ?? bodyCode,
      retryAfter,
    );
  } catch {
    return new AdminApiError(res.status, path, raw, headerCode, retryAfter);
  }
}
